<style>
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
  }
  
  .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: #2195A0;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #2195A0;
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  
  
  </style>
  
  
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>UPSI Parameter</strong>
      </span>
    </div>
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
  
  
              <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th style="min-width:200px"> <strong>Options</strong> </th>
                    <th style="min-width:200px"> <strong>Yes/No</strong> </th>
  
                  </tr>
                </thead>
                <tbody>
                  <tr style="line-height: 25px;">
                    <td style="min-width:200px">Send emails with attachments to recipients :</td>
                    <td style="min-width:200px;">
                      <label class="switch">
                        <input type="checkbox" [checked]="EmailWithAttachment" (change)="updateParam('EmailWithAttachment',EmailWithAttachment,EmailWithAttachment_id)"
                          [(ngModel)]="EmailWithAttachment" [disabled] = "!EmailUpsiAdd">
                        <span class="slider round"></span>
                      </label></td>
                  </tr>
  
                  <tr style="line-height: 25px;">
                    <td style="min-width:200px">Attachment to be password protected :</td>
                    <td style="min-width:200px">
                      <label class="switch">
                        <input type="checkbox" [checked]="AttachmentWithPassword" (change)="updateParam('AttachmentWithPassword',AttachmentWithPassword,AttachmentWithPassword_id)"
                          [(ngModel)]="AttachmentWithPassword"  [disabled] = "!EmailUpsiAdd || !EmailWithAttachment">
                        <span class="slider round"></span>
                      </label></td>
                  </tr>
                  <tr style="line-height: 25px;" *ngIf="!isUPSILiteActive">
                    <td style="min-width:200px">Email when Recipient is added:</td>
                    <td style="min-width:200px">
                      <label class="switch">
                        <input type="checkbox" [checked]="EmailToRecipient" (change)="updateParam('EmailToRecipient',EmailToRecipient,EmailToRecipient_id)"
                          [(ngModel)]="EmailToRecipient">
                        <span class="slider round"></span>
                      </label>
                    </td>
                  </tr>
                  <tr style="line-height: 25px;">
                    <td style="min-width:200px">Email when UPSI is added :</td>
                    <td style="min-width:200px">
                      <label class="switch">
                        <input type="checkbox" [checked]="EmailUpsiAdd" (change)="updateParam('EmailUpsiAdd',EmailUpsiAdd,EmailUpsiAdd_id)"
                          [(ngModel)]="EmailUpsiAdd">
                        <span class="slider round"></span>
                      </label>
                    </td>
                  </tr>
                  <tr style="line-height: 25px;">
                    <td style="min-width:200px">Email when UPSI is edited :</td>
                    <td style="min-width:200px">
  
                      <label class="switch">
                        <input type="checkbox" [checked]="EmailUpsiEdit" (change)="updateParam('EmailUpsiEdit',EmailUpsiEdit,EmailUpsiEdit_id)"
                          [(ngModel)]="EmailUpsiEdit">
                        <span class="slider round">
  
                        </span>
                      </label></td>
  
  
                  </tr>
  
  
  
                </tbody>
              </table>
  
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  <div class="modal " id="deleteConfirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete this item?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
            <i class="fa fa-times"></i>No</button>
          <button type="button" class="btn btn-sm btn-primary"  data-dismiss="modal">
            <i class="fa fa-check"></i>Yes</button>
        </div>
      </div>
    </div>
  </div>
  <app-alert2></app-alert2>